import api from '@groovepages/gd-lib/api';

const pagesUrl = () => `${ window.gdEnv.VUE_APP_API_URL }/groovepages`;
const coreUrl = () => `${ window.gdEnv.VUE_APP_API_URL }/groovedigital`;

export default {
  namespaced: true,
  state: {
    domains: [],
    domain: {},
    zone: {}
  },
  getters: {
    domains: state => {
      return state.domains;
    },
    selectedDomain: state => {
      return state.domain;
    },
    selectedDomainRecords: state => {
      return state.zone.dns_records;
    },
    selectedZone: state => {
      return state.zone;
    },
  },
  mutations: {
    setDomains(state, { domains }) {
      state.domains = domains;
    },
    clearDomains(state)
    {
      state.domains = [];
    },
    addDomain(state, { domain }) {
      state.domains.unshift(domain);
    },
    updateDomain(state, { id, domain }) {
      state.domains[state.domains.findIndex(el => el.id === id)] = domain;
    },
    removeDomain(state, { id }) {
      const deletedDomain = state.domains.map(item => item.id).indexOf(id);
      state.domains.splice(deletedDomain, 1);
    },
    selectDomain(state, { domain, zone })
    {
        state.domain = domain;
        state.zone = zone;
    },
    unselectDomain()
    {
        state.domain = null;
        state.zone = null;
    }
  },
  actions: {
    async getDomains({ commit }) {
      const { data } = await api.get(`${ coreUrl() }/domains`);
      const domains = data;
      commit('setDomains', { domains });
      return true;
    },
    async addDomain({ commit }, { name, type }) {
      const {status, domain, zone, message} = await api.post(`${ coreUrl() }/domains`, { name, type });
      
      if(status === 'success')
      {
        commit('addDomain', { domain });
        commit('selectDomain', { domain, zone });
        
      }
      return { status, message };
    },
    async getDomain({ commit }, { id }) {
      const {status, domain, zone} = await api.get(`${ coreUrl() }/domains/${ id }`);
      
      if(status === 'success')
      {
        commit('selectDomain', { domain, zone });
        return domain;
      }
      return false;
    },
    async deleteDomain({ commit }, { id }) {
      await api.delete(`${ coreUrl() }/domains/${ id }`);
      commit('removeDomain', { id });
    },
    async verifyDNSRecord({ commit }, { id }) {
      const { status, domain } = await api.get(`${ coreUrl() }/domains/check-status/${ id }`);
      commit('updateDomain', { id, domain });
      return status;
    },
    async skipDomainVerification({ commit }, { id }) {
      const { status, domain } = await api.post(`${ coreUrl() }/domains/skip-verification/${ id }`);
      commit('updateDomain', { id, domain });
      return status;
    },
    async setRootDomain({commit}, {selectedDomain, data}) {
        const { subdomain, domain } = await api.post(`${ coreUrl() }/domains/${ selectedDomain.id }/subdomains`, data);
        commit('updateDomain', { id: selectedDomain.id, domain });
        return subdomain;
    },
    async domain404UrlUpdate({ commit }, { id,data }) {
       const { status, domain } = await api.post(`${ coreUrl() }/domains/update-404-url/${ id }`, {data:data})
       commit('updateDomain', { id:id, domain });
        return status;
      },
    
  }
};